import { appThemeStyle } from "@/config";
import { homeStateSelector } from "@/store/redux/modules/home";
import { useSelector } from "react-redux";
const WeatherMainContent: React.FC<any> = ({ children, style, ...args }: any) => {
  const homeState = useSelector(homeStateSelector);
  const weatherStatus = homeState?.info?.weatherStatus || LocalStorage.getItem("info")?.weatherStatus;
  const mainItemStyle = appThemeStyle?.[weatherStatus]?.mainItemStyle ?? {};
  return (
    <div style={{ ...mainItemStyle, ...style }} {...args}>
      {children}
    </div>
  );
};
export default WeatherMainContent;
